import WellcomePortfolio from './WellcomePortfolio';
import GraphPortfolio from './GraphPortfolio';
import AllocationPortfolio from './AllocationPortfolio';

function Portfolio() {
  return (
    <>
      <WellcomePortfolio />
      <GraphPortfolio />
      <AllocationPortfolio />
    </>
  );
}

export default Portfolio;
